import React, {useEffect, useState} from 'react';
import {getCommissionsPayments} from "../../../../services/Profile";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import {currencyFormat} from "../../../../utils/masks";
import DivDiagonal from "../../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
} from "../../../Trading/styles";
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
    StrategyProductCard,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
    StrategyEmptyState,
} from "../../../Strategy/styles";

export default function PaymentCommission() {
  const [loadingList, setLoadingList] = useState(false);
  const { t } = useTranslation();
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);

  useEffect( () => {
    setLoadingList(true);
    getCommissionsPayments({
      page: page,
      per_page: 25,
    }).then((data) => {
      if (!data || data === '') {
        return;
      }

      setPayments(data.data);
    }).finally(() => {
      setLoadingList(false);
    });

    return function cleanup() {
      setPayments([]);
    };
  }, [page]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const rowCount = payments?.data?.length || 0;

    return (
        <TradingWrapper>
            <DivDiagonal/>
            <ContentArea>
                <StrategyPageHeader>
                    <h1>
                        <i className="fa fa-receipt" aria-hidden="true"/>
                        {' '}{t('admin_commission_payments_title')}{' '}
                        <span className="badge">{rowCount}</span>
                    </h1>
                </StrategyPageHeader>

                <StrategyWideCardColumn>
                    <StrategyProductCard>
                        <StrategyTableWrapper>
                            {loadingList ? (
                                <StrategyLoadingButton
                                    className="btn btn-primary text-capitalize font-weight-bold"
                                    loading={loadingList}
                                    type="button"
                                >
                                    {t('loading')}
                                </StrategyLoadingButton>
                            ) : (
                                <>
                                    {payments && payments.data && payments.data.length ? (
                                        <>
                                        {/* Mobile: cards */}
                                        <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'column', gap: 1.5, pt: 1.5, pb: 1, px: 1.5 }}>
                                            {payments.data.map((payment) => (
                                                <Box key={payment.id} sx={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.04)', px: 2, py: 1.5 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.88rem' }}>
                                                            {new Date(payment.created.date).toLocaleDateString()}
                                                        </span>
                                                        <span style={{ fontWeight: 700, color: '#5bd37c', fontSize: '0.95rem' }}>
                                                            {currencyFormat(parseFloat(payment.value ? payment.value : 0), 'R$')}
                                                        </span>
                                                    </Box>
                                                    <Box>
                                                        <span style={{ display: 'block', color: '#e0e0e0', fontSize: '0.85rem' }}>
                                                            {payment.affiliateUser ? payment.affiliateUser.email : ''}
                                                        </span>
                                                        <small style={{ color: 'rgba(255,255,255,0.45)' }}>
                                                            {t('admin_commissions_affiliate_id')}: {payment.affiliateUser ? (payment.affiliateUser.affiliateID).split('-')[0] : ''}
                                                        </small>
                                                    </Box>
                                                </Box>
                                            ))}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 4 }}>
                                                <StrategyPaginationInfo>{t('table_pagination_text', { page, totalPage: payments.total_page + 1 })}</StrategyPaginationInfo>
                                                <div style={{ display: 'flex', gap: 8 }}>
                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page - 1)} disabled={page <= 1}><IoIosArrowBack/> {t('table_pagination_back')}</StrategyPaginationButton>
                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page + 1)} disabled={!payments.next_page}>{t('table_pagination_next')} <IoIosArrowForward/></StrategyPaginationButton>
                                                </div>
                                            </div>
                                        </Box>

                                        {/* Desktop: tabela */}
                                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                        <StrategyTableContainer>
                                            <Table aria-label={t('admin_commission_payments_title')}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t('admin_commission_payments_col_date')}</TableCell>
                                                        <TableCell>{t('admin_commission_payments_col_affiliate')}</TableCell>
                                                        <TableCell>{t('admin_commission_payments_col_value')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {payments.data.map((payment) => (
                                                        <TableRow key={payment.id}>
                                                            <TableCell>{new Date(payment.created.date).toLocaleDateString()}</TableCell>
                                                            <TableCell>
                                                                {payment.affiliateUser ? payment.affiliateUser.email : ''}
                                                                <br/>
                                                                <small style={{ color: 'rgba(255,255,255,0.45)' }}>
                                                                    ID: {payment.affiliateUser ? (payment.affiliateUser.id).split('-')[0] : ''}
                                                                    <br/>
                                                                    {t('admin_commissions_affiliate_id')}: {payment.affiliateUser ? (payment.affiliateUser.affiliateID).split('-')[0] : ''}
                                                                </small>
                                                            </TableCell>
                                                            <TableCell>{currencyFormat(parseFloat(payment.value ? payment.value : 0), 'R$')}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TableCell colSpan={3}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                                                                <StrategyPaginationInfo>{t('table_pagination_text', { page, totalPage: payments.total_page + 1 })}</StrategyPaginationInfo>
                                                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page - 1)} disabled={page <= 1}><IoIosArrowBack/> {t('table_pagination_back')}</StrategyPaginationButton>
                                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page + 1)} disabled={!payments.next_page}>{t('table_pagination_next')} <IoIosArrowForward/></StrategyPaginationButton>
                                                                </div>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </StrategyTableContainer>
                                        </Box>
                                        </>
                                    ) : (
                                        <StrategyEmptyState>
                                            <i className="fa fa-receipt" aria-hidden="true"/>
                                            <p>{t('admin_commission_payments_empty_title')}</p>
                                            <span>{t('admin_commission_payments_empty_subtitle')}</span>
                                        </StrategyEmptyState>
                                    )}
                                </>
                            )}
                        </StrategyTableWrapper>
                    </StrategyProductCard>
                </StrategyWideCardColumn>
            </ContentArea>
        </TradingWrapper>
    );
}
